<script lang="ts">
import { useUserDefaultRole, useSignOut } from '@nhost/vue';
import { useCompanyStore } from '@/store/company';
import { useClientStore } from '@/store/client';
import { mapState } from 'pinia';
import { gql } from '@apollo/client/core';
import { apolloClient } from '@/plugins/nhost';
import nhost from '@/plugins/nhost';

const CHECK_USER_CLIENT = gql`
  query CheckUserClient($userId: uuid!, $clientId: uuid!) {
    general_user_client(where: { user_id: { _eq: $userId }, client_id: { _eq: $clientId } }) {
      user_id
    }
  }
`;

export default {
  setup() {
    const companyStore = useCompanyStore();
    const clientStore = useClientStore();
    return {
      companyStore,
      clientStore,
    };
  },
  computed: {
    ...mapState(useClientStore, ['selectedClientId', 'selectedClient']),
  },
  data() {
    return {};
  },
  methods: {
    clearLogoCache() {
      // Remove all cached logo images from localStorage
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('logoBase64_')) {
          localStorage.removeItem(key);
        }
      });
    }
  },
  async mounted() {
    const { value: role } = useUserDefaultRole();
    const { signOut } = useSignOut();
    let shouldSignOut = false;

    const controlTowerUrl = import.meta.env.VITE_APP_CONTROLTOWER_COMPANIES_URL;
    const cockpitUrl = import.meta.env.VITE_APP_COCKPIT_URL;

    let redirectUrl = '';
    let platform = localStorage.getItem('platform_origin');
    if (!platform) platform = 'cockpit';

    if (platform === 'dataroom') {
      shouldSignOut = true;
    } else if (platform === 'cockpit-portfolio') {
      // User opened the dataroom from the cockpit Portfolio page: send them back
      // there. The general_user_client check below does not apply, because the
      // selected client is the portfolio company's own client (which the cockpit
      // user does not own), so it would otherwise misroute to controltower.
      redirectUrl = `${cockpitUrl}/app/portfolio`;
    } else if (role === 'investor' || !this.selectedClient?.id) {
      redirectUrl = `${controlTowerUrl}/${this.companyStore.getCompany.id || ''}`;
    } else {
      try {
        const userId = (nhost as any).auth.getUser()?.id;
        const { data } = await apolloClient.query({
          query: CHECK_USER_CLIENT,
          variables: {
            userId,
            clientId: this.selectedClient.id
          },
        });

        if (data?.general_user_client?.length > 0) {
          redirectUrl = platform === 'controltower'
            ? `${controlTowerUrl}/${this.companyStore.getCompany.id || ''}`
            : cockpitUrl;
        } else {
          redirectUrl = `${controlTowerUrl}/${this.companyStore.getCompany.id || ''}`;
        }
      } catch (error) {
        console.error('Error checking user-client relationship:', error);
        redirectUrl = cockpitUrl;
      }
    }

    this.clientStore.clearSelectedClient();
    this.companyStore.clearCompany();
    this.clearLogoCache();
    localStorage.removeItem('platform_origin');
    
    if (shouldSignOut) {
      signOut().then(() => {
        window.location.href = '/sign-in';
      });
    } else {
      window.location.replace(redirectUrl);
    }
  },
};
</script>

<template>
  <main></main>
</template>
